export const scrollToElement = (ref) => {
    if (ref.current) {
        ref.current.scrollIntoView({
            behavior: "smooth",
            block: "start"      // або "start"/"end"
        });
    }
};
